<template>
    <div 
        id="summarized-text-wrapper" 
        class="ml-3 col-11 p-0 pb-4 pt-3"
        v-if="summarizedText"
    >
        <div 
            v-if="showSelliaActionStatus" 
            id="summarized-text-header"
            class="d-flex align-items-center gap-1 mb-1"
        >
            <Tooltip 
                v-if="false" 
                :title="__('Criado com') + ' SelliA'" 
                placement="bottom" 
                tooltipClass="custom-sellia-tooltip"
            >
                <IconTwoFourPointedStar size="16" color="#8869FD" hoverColor="#8869FD" />
            </Tooltip>
            <IconTwoFourPointedStar v-else size="16" color="#8869FD" hoverColor="#8869FD" />
            <span class="fs-8 lh-18 fw-500 text-custom-purple">
                {{ selliaActionStatus }} {{ __('com') }} <b>SelliA</b>
            </span>
        </div>
        <div v-else class="made-by-sellia text-custom-purple fs-8 lh-18 fw-500 d-flex gap-1 mt-2">
          <Tooltip 
            v-if="false" 
            placement="bottom" 
            tooltipClass="custom-sellia-tooltip"
          >
            <IconTwoFourPointedStar size="16" color="#8869FD" hoverColor="#8869FD"/> 
          </Tooltip>
          <IconTwoFourPointedStar v-else size="16" color="#8869FD" hoverColor="#8869FD"/>
          <b class="text-custom-purple fs-8 lh-18">
            {{ __('Criado com') }}
             SelliA
          </b>
        </div>
        <span class="fs-7 lh-21 fw-600 text-custom-dark-grey mt-2">
            Resumo: 
        </span>
        <p 
            v-if="!isEditing" 
            id="summarized-text" 
            v-html="summary" 
            class="fs-7 lh-21 fw-500 text-custom-dark-grey"
        ></p>
        <textarea 
            v-else
            id="summarized-text" 
            :value="summary" 
            @input="handleChangeSummary"
            class="fs-7 lh-21 fw-500 text-custom-dark-grey w-100 border-0 min-h-100"
        ></textarea>
        <SummaryControls @setIsEditing="setIsEditing" @discardSummary="discardSummary" :isEditing="isEditing"/>
    </div>
</template>

<script>
import SummaryControls from './Summary/Controls.vue';
import Tooltip from '../../components/Tooltip.vue';

export default {
    props: {
        summary: {
            type: String,
            required: true
        }
    },

    components: {
        SummaryControls,
        Tooltip
    },
    
    data() {
        return {
            selliaActionResponse: {},
            summarizedText: '',
            isEditing: false,  
        }
    },

    computed: {
        showSelliaActionStatus() {
            return this.selliaActionResponse.type != 'hidden' && this.selliaActionResponse.type != 'recording';
        },

        selliaActionStatus() {
            if (this.selliaActionResponse.type == 'finish') {
                return 'Criado';
            } else if (this.selliaActionResponse.type == 'info') {
                return 'Erro ao criar';
            } else {
                return 'Criando';
            }
        },
    },

    methods: {
        handleInsertSummarizedTextToTextarea(text) {
            const editorContent = document.getElementById('editor-content');
            if (editorContent) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(text, 'text/html');
                this.summarizedText = doc.body.textContent || '';
                this.$emit('summaryCreated', this.summarizedText);
            }
        },

        setIsEditing(isEditing) {
            this.isEditing = isEditing;
        },

        discardSummary() {
            this.isEditing = false;
            this.summarizedText = '';
            this.$emit('discardSummary');
        },

        handleChangeSummary(event) {
            const editData = {
                isEdited: false
            }
            
            if (event.target.value != this.summarizedText) {
                editData.original = this.summarizedText;
                editData.isEdited = true;
                this.$emit('summaryWasEdited', editData);
            }
            
            this.$emit('update:summary', event.target.value);
        },
    },



    mounted() {
        this.summarizedText = this.summary;

        Bus.$on('insertSummarizedTextToTextarea', (text) => {
            this.handleInsertSummarizedTextToTextarea(text);
        });

        Bus.$on('selliaActionResponse', (response) => {
            this.selliaActionResponse = response;
        });

        Bus.$on('activityCreated', () => {
            this.summarizedText = '';
        });
    }, 

    beforeDestroy() {
        Bus.$off('selliaActionResponse');
        Bus.$off('insertSummarizedTextToTextarea');
    }, 
}
</script>

<style> 
.min-h-100 {
    min-height: 100px;
}

.custom-sellia-tooltip.tooltip.b-tooltip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 60px;
  height: 44px;
  filter: drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.12)) drop-shadow(0px 15px 35px rgba(103, 110, 118, 0.08));
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;
  background: #000000 !important;
  opacity: 1 !important;
  border-radius: 8px !important;
  margin-top: 8px !important;
}

.custom-sellia-tooltip.tooltip.b-tooltip .arrow {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 20px;
  height: 12px;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: -6px -6px;
}

.custom-sellia-tooltip.tooltip.b-tooltip .arrow::before {
  content: '';
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 0;
  border-bottom: 6px solid #000000;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.custom-sellia-tooltip.tooltip.b-tooltip .tooltip-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
  width: 126px;
  height: 37px;
  background: #000000;
  border-radius: 8px;
  flex: none;
  order: 1;
  flex-grow: 1;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #FFFFFF;
}

</style>